<template>
  <div class="user-info-container">
    <div class="info">
      <div class="avatar">
        <img :src="show_info.avatar">
      </div>
      <div class="info-detail">
        <div class="line-1">
          <div class="info-left" :style="{'color': gc.main_color}">
            <p>欢迎您，</p>
            <span :style="{'text-decoration': !is_login || bind_state === 0 ? 'underline' : ''}" @click="jump(true)">{{show_info.desc_wel}}</span>
          </div>
          <div class="info-right" @click="jump(false)" v-if="is_login">
            <p :style="{'color': gc.main_color}" v-if="show_info.desc">{{show_info.desc}}</p>
            <svg v-if="show_info.arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="6" height="9" viewBox="0 0 6 9" fill="none">
              <mask id="mask0_1380:7825" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="6" height="9">
                <path d="M3.92657 4.49346L4.69562e-08 7.92577L0.946004 9L6 4.49346L0.907128 2.93413e-05L3.47018e-07 1.06116L3.92657 4.49346Z" fill="#C4C4C4"/>
              </mask>
              <g mask="url(#mask0_1380:7825)">
                <path d="M8.31958 9.52393L8.31958 -7.71619L-8.73442 -7.71619L-8.73442 9.52393L8.31958 9.52393Z" fill="url(#pattern0)"/>
              <rect x="-3" y="-1" width="9" height="10" :fill="gc.main_color"/>
              </g>
            </svg>
          </div>
        </div>
        <div class="line-2">
          <p class="text" :style="{'color': hexToRgba(gc.main_color, .7)}">我的积分:</p>
          <p class="num" :style="{'color': hexToRgba(gc.main_color, .8)}">{{is_login ? score_left : '-'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '_lib/event-bus'
import { utils, redirectUrlByServer } from '_lib/utils';
import { ComponentCommonMixin } from '../mixin'

export default {
  mixins: [ComponentCommonMixin],
  data () {
    return {
      score_left: '-',
      is_login: true,
      type: '',
      bind_state: -1,
    }
  },
  mounted () {
    this.type = this.cc.type
    // 绑定游戏战绩
    if (this.type) {
      if (Object.keys(this.cd).length === 0) {
        this.is_login = false // 只有绑定类型才会存在未登录
      } else {
        this.bind_state = this.cd[this.type].bind_state // //0:未绑定，1:未认证，2:已认证
      }
    }
    this.score_left = this.gd.score_left
    eventBus.$on("changeVal", (key, val) => {
      this[key] = val
    });
  },
  watch: {
    cd (cd) {
      if (this.type) {
        if (Object.keys(cd).length === 0) {
          this.is_login = false // 只有绑定类型才会存在未登录
        } else {
          this.bind_state = cd[this.type].bind_state // //0:未绑定，1:未认证，2:已认证
        }
      }
    },
    gd (gd) {
      this.score_left = gd.score_left
    }
  },
  computed: {
    show_info () {
      const obj = {
        desc_wel: '去登录',
        avatar: 'https://imgheybox.max-c.com/oa/2022/01/11/457abcd33d6f3249451cb4e435d7a360.jpeg',
        desc: '',
        arrow: false,
      }
      if (!this.is_login) {
        return obj
      }
      if (this.type && this.cd[this.type]) {
        let info = {}
        if (this.cd[this.type].player_info) {
          info = this.cd[this.type].player_info
        }
        obj.desc_wel = [this.cd[this.type].bind_msg, info.nickname, info.nickname][this.cd[this.type].bind_state]
        obj.avatar = [this.gd.user_info.avatar, info.avatar, info.avatar][this.cd[this.type].bind_state]
        obj.desc = [false, '去认证', '已认证'][this.cd[this.type].bind_state]
        obj.arrow = this.cd[this.type].bind_state == 1
      } else {
        obj.desc_wel = this.gd.user_info.username,
        obj.avatar = this.gd.user_info.avatar,
        obj.desc = this.cc.text,
        obj.arrow = this.cc.protocol || this.cc.url
      }
      return obj
    }
  },
  methods: {
    jump (is_desc_wel = false) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      // 左侧点击
      if (is_desc_wel) {
        if (this.type) {
          if (this.show_info.desc_wel === '去登录') {
            utils.executeProtocol({
              "protocol_type": "login"
            })
          } else{
            // 绑定战绩
            utils.executeProtocol(this.cd[this.type].bind_protocol)
            // window.location.href = this.cd[this.type].bind_protocol
          }
        }
      } else { // 右侧点击 
        if (this.cc.type === 'pubg') {
          if (this.cd[this.type].bind_state == 1) {
            // 去认证
            utils.executeProtocol({
              "protocol_type": "openWindow",
              "webview": {
                "url": redirectUrlByServer(window.location.origin + '/game/pubg/certify?os_type=webinapp', 'heybox') 
              },
              navigation_bar: {
                title: "PUBG认证"
              }
            })
          }
        } else {
          // 常规
          if (this.cc.url) {
            utils.executeProtocol({
              protocol_type: 'openWindow',
              webview: {
                url: this.cc.url
              },
            })
          }
          else if (this.cc.protocol) {
            utils.executeProtocol(this.cc.protocol)
            // window.location.href = this.cc.protocol
          }
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.user-info-container {
  margin: 32px 14px 0;
  .info {
    display: flex;
    width: 100%;
    
    .avatar {
      height: 50px;
      width: 50px;
      margin-right: 14px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .info-detail {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .line-1 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .info-left {
          display: flex;
          align-items: center;
          margin-bottom: 1px;
          img {
            height: 11px;
            width: 21px;
            margin-right: 4px;
          }
          p,span {
            font-size: 14px;
            line-height: 20px;
          }
          span {
            font-weight: 500;
          }
        }
        .info-right {
          display: flex;
          flex-direction: row;
          align-items: center;
          p {
            font-size: 12px;
            margin-right: 4px;
          }
          img {
            width: 6px;
            height: 10px;
            object-fit: fill;
          }
        }
      }
      .line-2 {
        display: flex;
        flex-direction: row;
        .text {
          margin-right: 7px;
          font-size: 12px;
          font-weight: 500;
          line-height: 17px;
        }
        .num {
          font: 14px/17px ALIBABA Font;
          opacity: .8;
        }
      }
    }
  }
}
</style>